export default "__VITE_ASSET__CDtu9xO6__"